import { DELEVER_SWITCH, ORDER_D_TYPE, DELIVER_TYPE } from '@/enum/order'
import { computed, reactive, ref } from 'vue'
import { $orderApi } from '@/utils/http/modules/order/order.request'
import { Toast } from 'vant'
import { useRequestList } from './useList'
import { useRoute } from '@/router/router'
import { $shopApi } from '@/utils/http/modules/shop/shop.request'
import store from '@/store'
const isOk = res => res && res.isok
/**
 * @param {number} orderDeliverType
 */
export const useDeliver = (orderDeliverType, subtotalUpdate) => {
  orderDeliverType = Number(orderDeliverType)
  const switchVisible = computed(
    () => orderDeliverType === ORDER_D_TYPE.slfCollectOrDel
  )
  const delieverSwitch = computed(() => store.state.setorder.delieverSwitch)
  const storeVisible = computed(
    () => delieverSwitch.value === DELEVER_SWITCH.store
  )
  const addressVisible = computed(
    () => delieverSwitch.value === DELEVER_SWITCH.address
  )
  const setDelieverSwitchDefault = () => {
    if (switchVisible.value) {
      store.commit('SET_DELIVERSWITCH', DELEVER_SWITCH.address)
    } else {
      store.commit(
        'SET_DELIVERSWITCH',
        orderDeliverType === ORDER_D_TYPE.deliver
          ? DELEVER_SWITCH.address
          : DELEVER_SWITCH.store
      )
    }
  }
  setDelieverSwitchDefault()
  const changeSwitch = val => {
    store.commit('SET_DELIVERSWITCH', val)
    subtotalUpdate()
  }
  return {
    switchVisible,
    delieverSwitch,
    storeVisible,
    addressVisible,
    changeSwitch,
  }
}
const addrDefault = () => ({
  Address: '',
  id: 0,
  realname: '',
  telphone: '',
})
/**
 * @name 普通地址与虚拟地址转换(都来源于$orderApi.getUsrusedAddr)
 * @param {*} addr
 * @param {Boolean} reverse
 */
export const virtAddrTansfer = (addr, reverse) => {
  const rule = [
    ['realname', 'UserName'],
    ['telphone', 'TelNumber'],
    ['id', 'id'],
  ]
  return rule.reduce((target, keys) => {
    keys = reverse ? keys.reverse() : keys
    target[keys[0]] = addr[keys[1]]
    return target
  }, {})
}
export const useAddress = () => {
  const addressInfo = reactive(addrDefault())
  const clearAddress = () => Object.assign(addressInfo, addrDefault())
  const getDefaultAddr = async () => {
    const res = await $orderApi.getUsrusedAddr()
    if (res && res.isok && res.data) {
      Object.assign(addressInfo, res.data)
    }
  }
  const initAddress = async () => {
    await getDefaultAddr()
  }
  const setVirtAddrInfo = async obj => {
    try {
      await $orderApi.setUsrAddr({
        ...obj,
        itemType: 1,
        IsDefault: true,
        mode: 2,
      })
      Object.assign(addressInfo, virtAddrTansfer(obj))
    } catch (error) {
      Toast(error)
    }
  }
  return {
    addressInfo,
    initAddress,
    clearAddress,
    setVirtAddrInfo,
  }
}
export const useAddressList = () => {
  const addressList = ref([])
  const choseId = ref(0)
  const size = 10
  const { request, reset, loading, finished } = useRequestList({
    finished: res => isOk(res) && (!res.dataObj || res.dataObj.length < size),
    pageIncrease: res => isOk(res),
  })
  const getAddrList = async _reset => {
    if (_reset) {
      addressList.value = []
      reset()
    }
    const res = await request(page => $orderApi.getUsrAddr({ page, size }))
    if (res && res.isok) {
      addressList.value = [...addressList.value, ...res.dataObj]
      choseId.value = !choseId.value
        ? (addressList.value.find(i => i.IsDefault) &&
            addressList.value.find(i => i.IsDefault).Id) ||
          0
        : choseId.value
    }
  }
  const setDefault = async id => {
    try {
      await $orderApi.setUsrAddrUsed({ id })
    } catch (error) {
      Toast(error)
    }
  }
  return {
    getAddrList,
    addressList,
    loading,
    finished,
    choseId,
    setDefault,
  }
}
export const storeDefault = () => ({
  address: '',
  areaName: '',
  cityName: '',
  id: 0,
  provinceName: '',
  title: '',
})
export const useStoreList = (prodId, locationUde) => {
  const query = useRoute().query
  const storeList = ref([])
  const storeChose = ref(-1)
  const allStoreList = ref([])
  const pageSize = 50
  const { request, reset, loading, finished } = useRequestList({
    finished: res =>
      isOk(res) && (!res.dataObj || res.dataObj.length < pageSize),
    pageIncrease: res => isOk(res),
  })
  const resetStoreList = () => {
    reset()
    storeList.value = []
  }
  const getAllStore = async () => {
    try {
      const result =
        (await $shopApi.getSelfTakeStoreArea({ zbId: window.zbvd.zbid })) || []
      // console.log('res-->', result)
      allStoreList.value = result.dataObj
    } catch (error) {
      Toast(error)
    }
  }
  getAllStore()
  const getStoreList = async (listQuery, _reset) => {
    _reset && resetStoreList()
    try {
      // if (listQuery.areaCode) {
      //   listQuery.cityCode = 0
      //   listQuery.provinceCode = 0
      // }
      const params = {
        zbid: query.zbId || query.zbid,
        id: prodId.value,
        ...locationUde,
        pageSize,
        ...listQuery,
      }
      // debugger
      const res = await request(pageIndex =>
        $orderApi.getSelfTakeStoreList({
          ...params,
          pageIndex,
        })
      )
      if (res && res.isok) {
        storeList.value = [...storeList.value, ...res.dataObj]
        // allStoreList.value = listQuery.area
        //   ? allStoreList.value
        //   : JSON.parse(JSON.stringify(res.dataObj))
        const storeUsed = res.dataObj.filter(item => item.isUsed)
        storeChose.value = (storeUsed.length && storeUsed[0].Id) || -1
      }
    } catch (error) {
      Toast(error)
    }
  }
  return {
    storeList,
    getStoreList,
    loading,
    finished,
    allStoreList,
    storeChose,
    locationUde,
    resetStoreList,
  }
}
export const saveAddress = params => {
  return $orderApi
    .setUsrAddr(params)
    .then(res => {
      return res && res.isok ? res : Promise.reject(res)
    })
    .catch(e => Promise.reject((e && e.msg) || e))
}

export function showStoreChose(orderDeliverType) {
  return Number(orderDeliverType) !== ORDER_D_TYPE.generalVerify
}
